import getJobName from "../../../GlobalFunctions/getJobName";
import UniversalTextField from "../../../GlobalComponents/UniversalTextField";

const JobTitle = ({ jobData, isSpecialEvent, clientOnlyMode = false }) => {
  if (clientOnlyMode) {
    return (
      <div
        style={{
          position: "absolute",
          top: 30,
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 99999,
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
        }}
      >
        <span
          style={{
            fontSize: 16,
            fontWeight: 800,
            userSelect: "text",
            WebkitUserSelect: "text",
            MozUserSelect: "text",
            msUserSelect: "text",
          }}
        >
          {jobData?.client || "Client Profile"}
        </span>
      </div>
    );
  } else if (isSpecialEvent) {
    if (!jobData || !jobData.id) {
      return null;
    }

    const specialEventContainerStyle = {
      position: "absolute",
      top: 35,
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 99999,
      minWidth: 250,
      textAlign: "center",
      width: "80%",
      mx: 2,
    };

    return (
      <div style={specialEventContainerStyle}>
        <UniversalTextField
          collectionName="JobData"
          docId={jobData.id}
          fieldName="title"
          value={jobData.title || ""}
          hiddenLabel
          variant="standard"
          adminOnly={false}
          fullWidth
          sx={{
            mt: 0,
            width: "100%",
            "& .MuiInputBase-input": {
              p: 0,
              m: 0,
              fontSize: 16,
              fontWeight: 800,
              textAlign: "center",
            },
            "& .MuiBox-root": {
              p: 0.8,
            },
          }}
        />
      </div>
    );
  } else {
    return (
      <div
        style={{
          position: "absolute",
          top: 30,
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 99999,
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          "-webkit-app-region": "no-drag",
          "app-region": "no-drag",
          appRegion: "no-drag",
        }}
      >
        <span
          style={{
            fontSize: 16,
            fontWeight: 800,
            userSelect: "text",
            WebkitUserSelect: "text",
            MozUserSelect: "text",
            msUserSelect: "text",
            "-webkit-app-region": "no-drag",
            "app-region": "no-drag",
            appRegion: "no-drag",
          }}
        >
          {getJobName(jobData)}
        </span>
      </div>
    );
  }
};

export default JobTitle;
